var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ipo-credit"}},[_c('header',[_c('Hero')],1),_vm._v(" "),_c('main',[_c('OpeningBullets'),_vm._v(" "),_c('Solution'),_vm._v(" "),_c(_vm.lazy,{tag:"component"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a43eb27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IpoCredit.vue
// module id = null
// module chunks = 